import ContentLoader from 'react-content-loader'
import times from 'lodash/times'

import theme from 'theme_'

interface RowsLoaderProps {
  rows: number
  height: number
  gap: number
}

function RowsLoader({ rows, height, gap }: RowsLoaderProps) {
  const rowHeightWithGap = height + gap

  return (
    <ContentLoader
      speed={2}
      width="100%"
      height={rows * rowHeightWithGap}
      backgroundColor={theme.colors.newLightGrey}
      foregroundColor={theme.colors.lightGrey}
    >
      {times(rows, (i) => (
        <rect
          key={i}
          x="0"
          y={i * rowHeightWithGap}
          rx="8"
          ry="8"
          width="100%"
          height={`${height}px`}
        />
      ))}
    </ContentLoader>
  )
}

export default RowsLoader
